import { Component, Input } from '@angular/core';

@Component({
  selector: 'pop-loading',
  templateUrl: './loading.component.html'
})
export class LoadingComponent {
  @Input() isInline = false;
}
